import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import OfferHeader from './components/OfferHeader';
import OfferActions from '../OfferActions';
import { offerAvailabilitySx } from '../utils';

const OfferListItem = ({
  offer,
  revalidateList,
  beforeClaimAction,
  allowUnavailableActions = false,
  grayOutUnavailable = true,
  showUnavailableLabels = false,
}) => {
  const isPreview = offer.isPreview
  return (
    <Card sx={{
      ...(grayOutUnavailable ? offerAvailabilitySx(offer.active, isPreview) : {}),
      width: '100%',
      maxWidth: 880,
      mx: 'auto',
      overflow: 'hidden',
      border: '1px solid',
      borderColor: 'rgba(14, 117, 189, 0.18)',
      borderLeft: '4px solid',
      borderLeftColor: 'primary.main',
      borderRadius: 2,
      boxShadow: '0 8px 24px rgba(19, 65, 99, 0.08)',
      transition: 'box-shadow 180ms ease, transform 180ms ease',
      '&:hover': {
        boxShadow: '0 12px 30px rgba(19, 65, 99, 0.13)',
        transform: 'translateY(-1px)',
      },
      '@media (prefers-reduced-motion: reduce)': {
        transition: 'none',
        '&:hover': { transform: 'none' },
      },
    }}>
      <OfferHeader
        offer={offer}
        isPreview={isPreview}
        showUnavailableLabels={showUnavailableLabels}
      />
      <CardContent
        sx={{
          paddingBottom: 0,
          paddingTop: 0,
          paddingLeft: 1.5,
          paddingRight: 1.5,
          flex: '1 1 40px',
          overflow: 'hidden',
          mb: 1,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {offer.description}
        </Typography>
      </CardContent>
      <OfferActions
        {...offer}
        isPreview={isPreview}
        revalidateList={revalidateList}
          beforeClaimAction={beforeClaimAction}
        allowUnavailableActions={allowUnavailableActions}
      />
    </Card>
  );
};

export default OfferListItem;
